.wrapper {
  padding: 24px 0;
}

.container {
  background: var(--main-background);
  width: 100%;
  max-width: 1200px;
  min-width: 650px;
  margin: 0 auto;
  padding: 10px 20px;
  box-sizing: border-box;
  border-radius: 8px;
}

@media (max-width: 600px) {
  .container {
    padding: 10px 15px;
    min-width: unset;
    width: 100%;
  }

  .header {
    flex-direction: column;
    gap: 12px;
  }

  .actions {
    margin-left: 0;
    align-self: flex-start;
  }
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  padding: 16px 0;
  border-bottom: 1px solid #e0e0e0;
}

.titleSection {
  flex: 1;
}

.actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  margin-left: 16px;
}

.title {
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0 0 4px 0;
  color: var(--main-text);
}

.reportSubtitle {
  font-size: 1rem;
  color: var(--main-text);
  margin: 0 0 4px 0;
  font-weight: 400;
}

.subtitle {
  font-size: 0.85rem;
  color: var(--secondary-text);
  margin: 0;
}

.content {
  line-height: 1.7;
  font-size: 0.95rem;
  color: var(--main-text);
}

.content a:not([class]) {
  color: var(--link-color, #1976d2);
  text-decoration: none;
}

.content a:not([class]):hover {
  text-decoration: underline;
}

@media print {
  .actions {
    display: none;
  }
}

.centered {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
  flex-direction: column;
  gap: 16px;
}
